import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CompetitiveData from './CompetitiveData';
import IvsEvs from './IvsEvs';
import TeraGuide from './TeraGuide';
import WeatherTerrain from './WeatherTerrain';
import PokemonBuilder from './PokemonBuilder';
import TeamBuilder from './TeamBuilder';
import './Competitive.css';

const Competitive = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('pokemon');
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    // Set initial tab based on URL path
    const path = location.pathname.split('/').pop();
    if (path && path !== 'competitive') {
      setActiveTab(path);
    }
  }, [location]);

  useEffect(() => {
    // Restore scroll position when returning from detail pages
    if (location.state?.scrollPosition) {
      window.scrollTo(0, location.state.scrollPosition);
    }
  }, [location.state]);

  const tabs = [
    { id: 'pokemon', label: 'Commonly Used Pokemon' },
    { id: 'ivs-evs', label: 'IVs/EVs Guide' },
    { id: 'tera', label: 'Terastallization Guide' },
    { id: 'weather-terrain', label: 'Weather & Terrain' },
    { id: 'builder', label: 'Build Your Pokémon' },
    { id: 'team-builder', label: 'Team Building Guide' }
  ];

  const handleTabChange = (tabId) => {
    setIsTransitioning(true);
    setActiveTab(tabId);
    
    // Update URL without full page reload
    navigate(`/competitive/${tabId === 'pokemon' ? '' : tabId}`, { replace: true });

    // Reset transition state after animation completes
    setTimeout(() => {
      setIsTransitioning(false);
    }, 300);
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'pokemon':
        return <CompetitiveData />;
      case 'ivs-evs':
        return <IvsEvs />;
      case 'tera':
        return <TeraGuide />;
      case 'weather-terrain':
        return <WeatherTerrain />;
      case 'builder':
        return <PokemonBuilder />;
      case 'team-builder':
        return <TeamBuilder />;
      default:
        return <CompetitiveData />;
    }
  };

  return (
    <div className="competitive">
      <div className="competitive__header">
        <h1>Competitive Guide</h1>
        <p>Master the art of Pokemon battling with our comprehensive guides and resources.</p>
      </div>

      <div className="competitive__tabs" role="tablist">
        {tabs.map(tab => (
          <button
            key={tab.id}
            role="tab"
            aria-selected={activeTab === tab.id}
            aria-controls={`panel-${tab.id}`}
            className={`competitive__tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => handleTabChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div 
        className={`competitive__content ${isTransitioning ? 'transitioning' : ''}`}
        role="tabpanel"
        id={`panel-${activeTab}`}
      >
        {renderContent()}
      </div>
    </div>
  );
};

export default Competitive; 